import { api } from "@/api";

// «Скачать» на странице идеи (замечание Айталы A-24) — это файл картинки идеи
// в PNG или JPEG. Раньше кнопка была `<a download>` на адрес самой страницы:
// браузер сохранял HTML или просто перезагружал страницу.
//
// Медиа лежат на другом хосте, и `download` у ссылки на чужой адрес браузер
// игнорирует, поэтому файл берём через api (fetch → blob) и сохраняем через
// object URL. Тип определяем по первым байтам, а не по заголовку: CDN с
// `auto=format` может отдать WebP/AVIF — такие перекодируем в JPEG.

const sniff = async (blob: Blob): Promise<"png" | "jpg" | null> => {
	const head = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
	if (head[0] === 0x89 && head[1] === 0x50 && head[2] === 0x4e && head[3] === 0x47) return "png";
	if (head[0] === 0xff && head[1] === 0xd8 && head[2] === 0xff) return "jpg";
	return null;
};

const toJpeg = async (blob: Blob): Promise<Blob> => {
	const bitmap = await createImageBitmap(blob);
	const canvas = document.createElement("canvas");
	canvas.width = bitmap.width;
	canvas.height = bitmap.height;
	const ctx = canvas.getContext("2d");
	if (!ctx) throw new Error("Canvas is not available");
	// У JPEG нет прозрачности: подкладываем белый, как фон страницы идеи.
	ctx.fillStyle = "#FFFFFF";
	ctx.fillRect(0, 0, canvas.width, canvas.height);
	ctx.drawImage(bitmap, 0, 0);
	bitmap.close();
	return new Promise((resolve, reject) =>
		canvas.toBlob((out) => (out ? resolve(out) : reject(new Error("JPEG encode failed"))), "image/jpeg", 0.92),
	);
};

const save = (blob: Blob, fileName: string) => {
	const href = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = href;
	a.download = fileName;
	a.rel = "noopener";
	document.body.append(a);
	a.click();
	a.remove();
	// Safari начинает загрузку не сразу — отзываем ссылку с запасом.
	setTimeout(() => URL.revokeObjectURL(href), 30_000);
};

/** Имя файла без расширения: буквы, цифры, точка и дефисы — без пробелов и слешей. */
const safeName = (name: string): string =>
	name
		.trim()
		.replace(/[^\p{L}\p{N}._-]+/gu, "-")
		.replace(/-+/g, "-")
		.replace(/^-|-$/g, "") || "idea";

export async function downloadIdeaImage(url: string, name: string): Promise<void> {
	const blob = await api.feed.imageFile(url);
	const kind = await sniff(blob);
	if (kind) {
		save(blob, `${safeName(name)}.${kind}`);
		return;
	}
	save(await toJpeg(blob), `${safeName(name)}.jpg`);
}
